import { render } from "./CTASectionCard.vue?vue&type=template&id=503597b2&scoped=true"
import script from "./CTASectionCard.vue?vue&type=script&lang=js"
export * from "./CTASectionCard.vue?vue&type=script&lang=js"

import "./CTASectionCard.vue?vue&type=style&index=0&id=503597b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503597b2"]])

export default __exports__